import { useTranslation } from '@/app/i18n/client'
import { languages, LanguageType } from '@/app/types/constantDataType'
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from '@/components/ui/accordion'
import { Label } from '@/components/ui/label'
import { RadioGroup, RadioGroupItem } from '@/components/ui/radio-group'
import React from 'react'
interface LanguageFilterType {
  value: LanguageType | string
  setValue: (value: LanguageType) => any
}

const LanguageFilter = ({ value, setValue }: LanguageFilterType) => {
  const { t } = useTranslation()
  return (
    <div className="shadow-[0_0_3px_0_rgba(0,0,0,0.06)] bg-neutral-50 border border-solid border-[#ebebeb] mt-[20px] rounded-[4px] mobile:mt-[10px]">
      <div>
        <Accordion type="single" collapsible defaultValue="Languages">
          <AccordionItem value="Languages">
            <AccordionTrigger className="text-[18px] font-semibold text-[#222] pb-[0px]">
              {t('Languages')}
            </AccordionTrigger>
            <AccordionContent>
              <div className="flex flex-col mt-[0px]">
                <RadioGroup
                  defaultValue={'English'}
                  className="flex gap-4 items"
                  id="product_type"
                  onClick={(e: React.MouseEvent<HTMLInputElement>) => {
                    const selectedValue = (e.target as HTMLInputElement).value
                    if (selectedValue) {
                      setValue(selectedValue as LanguageType)
                    }
                  }}
                >
                  <div className="flex flex-col gap-2 checked-color">
                    {languages.map((language: string) => (
                      <Label
                        key={language}
                        htmlFor={language}
                        className=" cursor-pointer flex gap-2 text-sm not-italic leading-[normal] tracking-[normal] text-left text-[#6f6f6f]"
                      >
                        <RadioGroupItem
                          value={language}
                          className="!text-[#df7d2f]"
                          id={language}
                          checked={language == value}
                        />
                        {t(language)}
                      </Label>
                    ))}
                  </div>
                </RadioGroup>
              </div>
            </AccordionContent>
          </AccordionItem>
        </Accordion>
      </div>
    </div>
  )
}

export default LanguageFilter
